const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
// "New hire profile ready to review" carries its review page; only that exact path is followed.
const NEW_HIRE_REVIEW = new RegExp(`^/admin/people-hr/new-hire/(${UUID})$`, 'i');

export function hrNotificationLink(notification) {
  if (['oig_screening_complete', 'oig_screening_failed'].includes(notification?.templateId)) return '/admin/exclusion-checks';
  const applicantId = notification?.data?.applicantId;
  if (notification?.templateId?.startsWith('hr_applicant_') && typeof applicantId === 'string' && new RegExp(`^${UUID}$`, 'i').test(applicantId)) return `/admin/people-hr/applicants?applicant=${applicantId}`;
  const actionUrl = notification?.data?.actionUrl;
  const profileId = notification?.templateId?.startsWith('hr_new_hire_') && typeof actionUrl === 'string' ? actionUrl.match(NEW_HIRE_REVIEW)?.[1] : null;
  if (profileId) return `/admin/people-hr/new-hire/${profileId}`;
  const id = notification?.data?.recordId;
  return notification?.templateId?.startsWith('hr_followup_') && typeof id === 'string' && new RegExp(`^${UUID}$`, 'i').test(id) ? `/admin/people-hr?record=${id}` : null;
}
